import { render, staticRenderFns } from "./createMessage.vue?vue&type=template&id=2b72f524&scoped=true&"
import script from "./createMessage.vue?vue&type=script&lang=js&"
export * from "./createMessage.vue?vue&type=script&lang=js&"
import style0 from "./createMessage.vue?vue&type=style&index=0&id=2b72f524&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b72f524",
  null
  
)

export default component.exports